import { ReorderSortBy, SmartReplenishmentSortBy, SortOrder } from '../searcher.types';

export const REORDER_SORTING_OPTIONS = [
    {
        text: 'ORDER.PRODUCT_SEARCH.STOCK_RATIO_SORTING',
        value: {
            sortBy: ReorderSortBy.StockRatio,
            sortOrder: SortOrder.DESC
        }
    },
    {
        text: 'ORDER.PRODUCT_SEARCH.DISCOUNT_SORTING',
        value: {
            sortBy: ReorderSortBy.Discount,
            sortOrder: SortOrder.DESC
        }
    },
    {
        text: 'ORDER.PRODUCT_SEARCH.PURCHASE_PRICE_ASC',
        value: {
            sortBy: ReorderSortBy.PurchasePrice,
            sortOrder: SortOrder.ASC
        }
    },
    {
        text: 'ORDER.PRODUCT_SEARCH.PURCHASE_PRICE_DESC',
        value: {
            sortBy: ReorderSortBy.PurchasePrice,
            sortOrder: SortOrder.DESC
        }
    },
    {
        text: 'ORDER.PRODUCT_SEARCH.RRP_ASC',
        value: {
            sortBy: ReorderSortBy.RRP,
            sortOrder: SortOrder.ASC
        }
    },
    {
        text: 'ORDER.PRODUCT_SEARCH.RRP_DESC',
        value: {
            sortBy: ReorderSortBy.RRP,
            sortOrder: SortOrder.DESC
        }
    },
    {
        text: 'ORDER.PRODUCT_SEARCH.GROUP_ARTICLES_ASC',
        value: {
            sortBy: ReorderSortBy.ArticleNumber,
            sortOrder: SortOrder.ASC
        }
    },
    {
        text: 'ORDER.PRODUCT_SEARCH.GROUP_ARTICLES_DESC',
        value: {
            sortBy: ReorderSortBy.ArticleNumber,
            sortOrder: SortOrder.DESC
        }
    }
];

export const ADDITIONAL_BRAND_SHOP_SORTING_OPTIONS = [
    {
        text: 'ORDER.PRODUCT_SEARCH.NOS_FIRST',
        value: {
            sortBy: ReorderSortBy.NOS,
            sortOrder: SortOrder.DESC
        }
    },
    {
        text: 'ORDER.PRODUCT_SEARCH.SEASONAL_FIRST',
        value: {
            sortBy: ReorderSortBy.SEASON,
            sortOrder: SortOrder.DESC
        }
    },
    {
        text: 'ORDER.PRODUCT_SEARCH.CURRENT_SEASON',
        value: {
            sortBy: ReorderSortBy.CurrentSeason,
            sortOrder: SortOrder.DESC
        }
    }
];

export const SMART_REPLENISHMENT_SORTING_OPTIONS = [
    {
        text: 'ORDER_SMART_REPLENISHMENT.ITEMS_SOLD',
        value: {
            sortBy: SmartReplenishmentSortBy.ItemsSold,
            sortOrder: SortOrder.DESC
        }
    },
    {
        text: 'ORDER_SMART_REPLENISHMENT.STOCK_TURN_ASC',
        value: {
            sortBy: SmartReplenishmentSortBy.StockTurn,
            sortOrder: SortOrder.ASC
        }
    },
    {
        text: 'ORDER_SMART_REPLENISHMENT.STOCK_TURN_DESC',
        value: {
            sortBy: SmartReplenishmentSortBy.StockTurn,
            sortOrder: SortOrder.DESC
        }
    },
    {
        text: 'ORDER_SMART_REPLENISHMENT.SELL_THROUGH_ASC',
        value: {
            sortBy: SmartReplenishmentSortBy.SellThrough,
            sortOrder: SortOrder.ASC
        }
    },
    {
        text: 'ORDER_SMART_REPLENISHMENT.SELL_THROUGH_DESC',
        value: {
            sortBy: SmartReplenishmentSortBy.SellThrough,
            sortOrder: SortOrder.DESC
        }
    },
    {
        text: 'ORDER_SMART_REPLENISHMENT.LATEST_INVENTORY',
        value: {
            sortBy: SmartReplenishmentSortBy.LatestInventory,
            sortOrder: SortOrder.DESC
        }
    },
    {
        text: 'ORDER_SMART_REPLENISHMENT.ARTICLE_NUMBER_AND_COLOR',
        value: {
            sortBy: SmartReplenishmentSortBy.ArticleNumberColor,
            sortOrder: SortOrder.ASC
        }
    }
];
